<template>
  <el-card class="h-full relative" :body-style="{ padding: '20px', height: '100%' }">
    <div class="h-full border-1 p-10px">
      <div class="font-bold text-center mt-10px">{{ tableName }}</div>
      <el-button
        type="primary"
        size="small"
        @click="$router.go(-1)"
        class="absolute top-34px right-20px"
        >返回</el-button
      >
      <div class="h-[calc(100%-34px)]">
        <el-tabs v-model="activeName" class="h-full">
          <el-tab-pane label="数据预览" name="first" class="h-full">
            <div>
              <el-select v-model="search.column" filterable clearable class="w-200px mr-10px">
                <el-option
                  v-for="(item, index) in columnList"
                  :key="index"
                  :label="item.metaDataName ? item.metaDataName : item.metaDataCode"
                  :value="item.metaDataCode"
                ></el-option>
              </el-select>
              <el-input
                v-model="search.value"
                clearable
                class="w-200px mr-10px"
                placeholder="值"
              ></el-input>
              <el-input
                v-model="search.minimum"
                clearable
                class="w-200px mr-10px"
                placeholder="区域下限"
              ></el-input>
              <el-input
                v-model="search.maximum"
                clearable
                class="w-200px mr-10px"
                placeholder="区域上限"
              ></el-input>
              <el-button type="primary" @click="searchPreviewData">搜索</el-button>
              <el-button type="primary" @click="resetPreviewData">重置</el-button>
            </div>
            <!-- 动态列表格-->
            <el-table
              class="mt-20px"
              ref="table"
              :data="previewData"
              v-loading="previewLoading"
              border
              :highlight-current-row="true"
              height="calc(100% - 107px)"
            >
              <el-table-column
                type="index"
                v-if="previewHeader.length"
                width="60"
                :label="`${$t('seqNo')}`"
                sortable
              ></el-table-column>
              <el-table-column
                v-for="(val, index) in previewHeader"
                :prop="val.metaDataCode"
                show-overflow-tooltip
                :key="index"
                :label="val.metaDataName ? val.metaDataName : val.metaDataCode"
                min-width="150"
              >
                <template slot-scope="scope">
                  <div class="truncate">
                    {{ scope.row[`${val.metaDataCode}`] }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页-->
            <div class="mt-20px float-right pagination">
              <el-pagination
                background
                @current-change="previewCurrentChange"
                @size-change="previewSizeChange"
                :current-page.sync="previewPage.pageNo"
                :page-size="previewPage.pageSize"
                :page-sizes="$pageSizeAll"
                layout="total, sizes, prev, pager, next"
                :total="previewPage.total"
              ></el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="表结构" name="second" class="h-full">
            <!-- 动态列表格-->
            <el-table
              ref="table"
              :data="tableData"
              v-loading="tableLoading"
              border
              :highlight-current-row="true"
              height="100%"
            >
              <el-table-column label="代码" prop="metaDataCode" show-overflow-tooltip>
              </el-table-column>
              <el-table-column label="名称" prop="metaDataName" show-overflow-tooltip>
              </el-table-column>
              <el-table-column label="数据类型" prop="dataType" show-overflow-tooltip>
              </el-table-column>
              <el-table-column label="长度" prop="dataLong" show-overflow-tooltip>
              </el-table-column>
              <el-table-column label="精度" prop="dataPrecision" show-overflow-tooltip>
              </el-table-column>
              <el-table-column label="单位" prop="unitName" show-overflow-tooltip>
              </el-table-column>
              <el-table-column label="默认值" prop="dataDefault" show-overflow-tooltip>
              </el-table-column>
              <el-table-column label="是否唯一性" prop="dataKey" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.dataKey === 1 ? '是' : '否' }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="是否非空" prop="dataIsNotNull" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.dataIsNotNull === 1 ? '是' : '否' }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </el-card>
</template>

<script>
import StickerSourceManagementService from '@/services/StickerSourceManagementService'

export default {
  data() {
    return {
      activeName: 'first',
      search: {
        column: '',
        value: '',
        maximum: '',
        minimum: '',
      },
      columnList: [],
      previewHeader: [],
      previewData: [],
      previewLoading: false,
      previewPage: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      tableLoading: false,
    }
  },
  computed: {
    tableName() {
      return this.$route.query.name
    },
  },
  watch: {
    activeName: {
      handler(val) {
        if (val === 'first') {
          this.getTableColumns()
          this.searchPreviewData()
        } else if (val === 'second') {
          this.searchTableData()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async getTableColumns() {
      const res = await StickerSourceManagementService.getTableColumns({
        metaDataManageId: this.$route.query.id,
      })
      if (res && res.code === 0) {
        this.columnList = res.data
        this.previewHeader = res.data
      }
    },
    async searchPreviewData() {
      this.previewLoading = true
      const res = await StickerSourceManagementService.getTCollectTableDatas({
        ...this.search,
        DestTableCode: this.$route.query.destTableCode,
        SkipCount: (this.previewPage.pageNo - 1) * this.previewPage.pageSize,
        MaxResultCount: this.previewPage.pageSize,
      })
      this.previewLoading = false
      if (res && res.code === 0) {
        this.previewData = res.data
        this.previewPage.total = res.totalCount
      }
    },
    resetPreviewData() {
      this.search = this.$options.data().search
      this.searchPreviewData()
    },
    previewCurrentChange(num) {
      this.previewPage.pageNo = num
      this.searchPreviewData()
    },
    previewSizeChange(size) {
      this.previewPage.pageSize = size
      this.searchPreviewData()
    },
    async searchTableData() {
      this.tableLoading = true
      const res = await StickerSourceManagementService.getTableColumns({
        metaDataManageId: this.$route.query.id,
      })
      this.tableLoading = false
      if (res && res.code === 0) {
        this.tableData = res.data
      }
    },
  },
}
</script>

<style lang="scss" scoped>

/deep/.el-tabs__content {
  height: calc(100% - 60px) !important;
}

</style>
